import React, {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

import {
    getPublicProfile,
} from "../services/publicApi";

const PublicSiteContext =
    createContext(null);


export const PublicSiteProvider = ({
    children,
}) => {

    const [siteData, setSiteData] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState(null);


    useEffect(() => {

        const loadSite = async () => {

            try {

                setLoading(true);

                const result =
                    await getPublicProfile();

                if (result.success) {
                    setSiteData(
                        result.data
                    );
                }

            } catch (err) {

                console.error(err);

                setError(
                    err.message
                );

            } finally {

                setLoading(false);

            }
        };

        loadSite();

    }, []);


    return (
        <PublicSiteContext.Provider
            value={{
                siteData,
                loading,
                error,
            }}
        >
            {children}
        </PublicSiteContext.Provider>
    );
};


export const usePublicSite = () => {

    const context =
        useContext(
            PublicSiteContext
        );

    if (!context) {
        throw new Error(
            "usePublicSite must be used inside PublicSiteProvider"
        );
    }

    return context;
};